<template>
  <div
    class="form-group d-flex input-in-grid"
    :title="debug"
  >
    <k-input
      style="box-shadow: none!important;"
      id="inputInGrid"
      ref="inputInGrid"
      :class="this.inputClassScc"
      :type="this.type"
      v-model="valueInputForEdit"
      v-kendo-validator="validateInput()"
      @keypress="keyEvent($event)"
      min="0"
      :step="this.stepNumber"
      :tabIndex="tabIndex"
    ></k-input>
    <k-input
      v-if="!this.edit"
      :class="this.displayCss"
      :style="this.headerStyle ? {fontWeight: 600} : ''"
      :value="valueInput"
      :disabled="true"
      :tabIndex="-1"
    ></k-input>
    <div class="nav-item nav-icon">
      <a class="cursor-pointer" id="navbarHelp" data-bs-toggle="help" aria-expanded="false">
        <i class="icon-attention text-danger" v-b-tooltip.hover :title="this.validationMsg" v-if="validationMsg !== ''"></i>
      </a>
    </div>
  </div>
</template>
<script>
import kendo from "@progress/kendo-ui";
import FormatNumberService from "../../services/format-number-service";
const integerRegex = /^\d+$/;
const decimalRegex = /^[+-]?([0-9]*[.])?[0-9]+$/;
export default {
  name: "input-in-grid",
  props: {
    value: String,
    displayType: String,
    edit: Boolean,
    allowOnlyNumber: Boolean,
    allowOnlyIntegerNumber: Boolean,
    allowNegativeNumber: Boolean,
    notRoundUp: Boolean,
    decimal: Number,
    headerStyle: Boolean,
    negativeDisplay: Boolean,
    max: Number,
    debug: String,
    tabIndex: Number,
    fadedText: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valueInput: "",
      highlightTextbox: false,
      maxData: 9999999,
      validationMsg: "",
      type: "text",
      stepNumber: "1",
      negativeNumber: false,
      inputClassScc: "",
      displayCss: "",
      valueInputForEdit: "",
      valueInputBeforeFormat: 0
    }
  },
  mounted() {
    this.updateValues();
    this.setInputClassCss();
  },
  watch: {
    edit: function() {
      this.updateValues();
      this.setInputClassCss();
      if (this.edit) {
        this.type = "number";
        this.stepNumber = this.allowOnlyIntegerNumber ? "1" : "any";
        this.showInputEdit();
      }
      else {
        this.type = "text";
        this.hideInputEdit();
      }
    },
    highlightTextbox: function() {
      this.setInputClassCss();
    },
    displayType: function() {
      this.updateValues();
    },
    valueInput: function() {
      if (!isNaN(this.valueInput)) {
        this.valueInputBeforeFormat = this.valueInput;
      }

      const validator = kendo.jQuery(this.$refs.inputInGrid.$el).getKendoValidator();
      var ele = kendo.jQuery(this.$refs.inputInGrid.$el)[0].children[0];
      validator.validateInput(ele);
      if (this.edit && this.allowOnlyNumber) {
        if (this.allowOnlyIntegerNumber && !integerRegex.test(Number(this.valueInput))) {
          this.valueInput = Math.floor(Number(this.valueInput));
        }
        if (Number(this.valueInput) < 0 && !this.allowNegativeNumber) {
          this.valueInput = Math.abs(Number(this.valueInput));
        }
        if (isNaN(this.valueInput)) {
          let numb = this.valueInput.match(/\d/g);
          if (numb !== null) {
            numb = numb.join("");
          }
          else {
            numb = "";
          }
          this.valueInput = numb;
        }
      }
      if (!isNaN(this.valueInput)) {
        this.updateNegativeNumber(this.valueInput, true);
        this.valueInput = this.formatValue(this.valueInput);
      }
      this.setInputClassCss();
    },
    valueInputForEdit: function() {
      if (this.edit && this.allowOnlyNumber) {
        if (this.allowOnlyIntegerNumber && !integerRegex.test(Number(this.valueInputForEdit))) {
          this.valueInputForEdit = Math.floor(Number(this.valueInputForEdit));
        }
        if (Number(this.valueInputForEdit) < 0 && !this.allowNegativeNumber) {
          this.valueInputForEdit = Math.abs(Number(this.valueInputForEdit));
        }
        if (Number(this.valueInputForEdit) > this.max) {
          this.valueInputForEdit = this.max;
        }
        if (isNaN(this.valueInputForEdit)) {
          let numb = this.valueInputForEdit.match(/\d/g);
          if (numb !== null) {
            numb = numb.join("");
          }
          else {
            numb = "";
          }
          this.valueInputForEdit = numb;
        }
      }
      this.valueInput = this.valueInputForEdit;
      this.reValidation();
    },
    value: function() {
      this.updateValues();
      this.setInputClassCss();
    },
    negativeNumber: function() {
      this.setInputClassCss();
    },
    fadedText: function() {
      this.setInputClassCss();
    },
  },
  methods: {
    updateValues() {
      this.valueInput = this.formatValue(this.value);
      this.valueInputForEdit = this.valueInput;
      this.updateNegativeNumber(this.value, false);
    },
    updateNegativeNumber(numberValue, percentage) {
      if (this.negativeDisplay) {
        this.negativeNumber = true;
      } else if (percentage) {
        this.negativeNumber = this.allowNegativeNumber ? false : this.displayType === "currency" || this.displayType === "currencyDecimal" || this.displayType === "percentage" || this.displayType === "percentageDecimal" ? Number(numberValue) < 0 : false;
      } else {
        this.negativeNumber = this.allowNegativeNumber ? false : this.displayType === "currency" || this.displayType === "currencyDecimal" ? Number(this.numberValue) < 0 : false;
      }
    },
    formatValue(amount) {
      switch(this.displayType) {
        case "percentage":
          return this.formatAsPercentage(amount);
        case "percentageDecimal":
          return this.formatAsPercentageDecimal(amount, this.decimal);
        case "currency":
          return this.edit ? Number(amount) : this.getFormatNumber(amount);
        case "currencyDecimal":
          return this.edit ? Number(amount).toFixed(2) : this.getFormatNumberWithDecimal(amount, this.decimal);
        case "none-format-currency":
          return Number(amount).toFixed(2);
        case "none-format-percentage":
          return Number(amount);
        //just integer number - none format
        case "none":
          return Number(amount).toFixed();
        //just decimal number - none format
        case "decimalNonFormat":
          return Number(amount).toFixed(this.decimal);
        case "string":
          return String(amount);
      }
      return amount;
    },
    getFormatNumber(amount) {
      const result = FormatNumberService.formatNumberResult(amount);
      return result;
    },
    getFormatNumberWithDecimal(amount, decimal) {
      const result = FormatNumberService.formatNumberResultWithDecimal(amount, decimal);
      return result;
    },
    formatAsPercentage(amount) {
      return FormatNumberService.formatNumberPercentage(Number(amount));
    },
    formatAsPercentageDecimal(amount, decimal) {
      return FormatNumberService.formatNumberPercentageWithDecimal(Number(amount), decimal);
    },
    validateInput: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          invalid: function () {
            if (vm.edit && vm.allowOnlyNumber) {
              const checkContainOnlyNumber = vm.allowOnlyIntegerNumber ? integerRegex.test(Number(vm.valueInputForEdit)) : decimalRegex.test(Number(vm.valueInputForEdit));
              if (!checkContainOnlyNumber || Number(vm.valueInputForEdit) > vm.maxData || (!vm.allowNegativeNumber && Number(vm.valueInputForEdit) < 0) || vm.valueInputForEdit.toString().trim() === "") {
                vm.highlightTextbox = true;
                if (vm.valueInputForEdit.toString().trim() === "") {
                  vm.validationMsg = "Field cannot be empty";
                }
                else if (!isNaN(vm.valueInput) && Number(vm.valueInput) > vm.maxData) {
                  vm.validationMsg = "Can not exceed $9,999,999";
                }
                else {
                  vm.validationMsg = "Invalid input";
                }
              }
              else {
                vm.highlightTextbox = false;
                vm.validationMsg = "";
              }
            }
            else if (vm.edit && !vm.allowOnlyNumber) {
              if (vm.valueInputForEdit.toString().trim() === "") {
                vm.highlightTextbox = true;
                vm.validationMsg = "Invalid input"
              }
              else {
                vm.highlightTextbox = false;
                vm.validationMsg = "";
              }
            }
            else {
              vm.highlightTextbox = false;
              vm.validationMsg = "";
            }
            return true;
          }
        },
        messages: {
            invalid: ""
        }
      }
    },
    keyEvent(event) {
      if (this.allowOnlyNumber) {
        if ((isNaN(event.key) && this.allowOnlyIntegerNumber && event.key === ".") || (isNaN(event.key) && event.key === "e")) {
          event.preventDefault();
        }
      }
    },
    setInputClassCss() {
      const faded = this.fadedText ? " faded-text-forced" : "";
      if (this.highlightTextbox) {
        this.inputClassScc = "form-control-sm invalid text-black" + faded;
      }
      else {
        if (!this.negativeNumber && this.allowNegativeNumber && ((this.displayType === "currency" || this.displayType === "currencyDecimal" || this.displayType === "percentage" || this.displayType === "percentageDecimal") && ((Number(this.value) < 0) || Number(this.valueInputBeforeFormat) < 0))) {
          this.displayCss = this.headerStyle ? "header-style form-control-sm text-red" + faded : "form-control-sm text-red" + faded;
          this.inputClassScc = this.edit ? "form-control-sm text-black" + faded : "d-none" + faded;
        }
        else if (this.negativeNumber) {
          this.displayCss = this.headerStyle ? "header-style form-control-sm text-red" + faded : "form-control-sm text-red" + faded;
          this.inputClassScc = this.edit ? "form-control-sm text-red" + faded : "d-none" + faded;
        }
        else {
          this.displayCss = this.headerStyle ? "header-style form-control-sm text-black" + faded : "form-control-sm text-black" + faded;
          this.inputClassScc = this.edit ? "form-control-sm text-black" + faded : "d-none" + faded;
        }
      }
    },
    showInputEdit() {
      const input = document.getElementById("inputInGrid");
      if (input) {
        input.classList.remove("d-none");
      }
    },
    hideInputEdit() {
      const input = document.getElementById("inputInGrid");
      if (input) {
        input.classList.add("d-none");
      }
    },
    reValidation() {
      if (this.edit && this.allowOnlyNumber) {
        const checkContainOnlyNumber = this.allowOnlyIntegerNumber ? integerRegex.test(Number(this.valueInputForEdit)) : decimalRegex.test(Number(this.valueInputForEdit));
        if (!checkContainOnlyNumber || Number(this.valueInputForEdit) > this.maxData || (!this.allowNegativeNumber && Number(this.valueInputForEdit) < 0) || this.valueInputForEdit.toString().trim() === "") {
          this.highlightTextbox = true;
          if (this.valueInputForEdit.toString().trim() === "") {
            this.validationMsg = "Field cannot be empty";
          }
          else if (!isNaN(this.valueInputForEdit) && Number(this.valueInputForEdit) > this.maxData) {
            this.validationMsg = "Can not exceed $9,999,999";
          }
          else {
            this.validationMsg = "Invalid input";
          }
        }
        else {
          this.highlightTextbox = false;
          this.validationMsg = "";
        }
      }
    }
  }
}
</script>
